import React, { FC, useState } from 'react';
import Popover from '@mui/material/Popover';
import CommentIcon from '@mui/icons-material/Comment';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from './styles';
import { AppState } from '../../../store';
import { FlashTabStrings } from '../../../store/bulk-device-flash/types';
import AcceptIcon from '../../../assets/icons/accept-icon';
import CancelIcon from '../../../assets/icons/cancel-icon';
import { updateFirmwareComment } from './calls';

const UpdateComment: FC<any> = ({
  row,
}: {
  row: {
    original: {
      preFlashComment: string;
      postFlashComment: string;
      deviceKey: string;
    };
  };
}) => {
  const classes = useStyles();
  const login = useSelector((state: AppState) => state.login);
  const logTab = useSelector((state: AppState) => state.bulkFlash.logTab);
  const dispatch = useDispatch();
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const loadedComments =
    logTab === FlashTabStrings.preFlash
      ? row?.original?.preFlashComment || null
      : row?.original?.postFlashComment || null;
  const [comments, setComments] = useState<string | null>(loadedComments);
  const [commentsSaved, setCommentsSaved] = useState<boolean | string>(false);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorElement(event.currentTarget);
  };
  const handleTextChange = (event: any) => {
    setComments(event.target.value);
  };
  const handlePopoverClose = () => {
    setAnchorElement(null);
  };
  const handleAcceptChanges = async () => {
    handlePopoverClose();
    const status = await updateFirmwareComment({
      deviceKey: row.original.deviceKey,
      commentsToSave: comments || '',
      login,
      logTab,
      dispatch,
    });
    setCommentsSaved(status);
  };
  const open = Boolean(anchorElement);
  const displayableComment =
    (loadedComments && !commentsSaved) || (commentsSaved && commentsSaved !== 'empty');
  return (
    <div>
      <Box display="flex" justifyContent="center">
        {displayableComment ? (
          <Typography className={classes.noWrap} onClick={handlePopoverOpen}>
            {commentsSaved || loadedComments?.toString()}
          </Typography>
        ) : (
          <IconButton className={classes.iconButtonSmall} size="small" onClick={handlePopoverOpen}>
            <CommentIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      {open && (
        <Popover
          id="update-comment-popover"
          classes={{
            paper: classes.paper,
          }}
          open={open}
          onClose={handlePopoverClose}
          anchorEl={anchorElement}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          disableRestoreFocus
        >
          <TextField
            id="outlined-multiline-static"
            label="Comments"
            multiline
            rows={4}
            defaultValue={comments}
            onChange={handleTextChange}
            variant="outlined"
          />
          {comments !== loadedComments && (
            <Box
              pl={1}
              display="flex"
              width="100%"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="subtitle2">Save</Typography>
              <Box>
                <IconButton id="comments-confirm" onClick={handleAcceptChanges} size="large">
                  <AcceptIcon />
                </IconButton>
                <IconButton
                  id="comments-deny"
                  onClick={handlePopoverClose}
                  aria-label="edit"
                  size="large">
                  <CancelIcon />
                </IconButton>
              </Box>
            </Box>
          )}
        </Popover>
      )}
    </div>
  );
};

export default UpdateComment;
